import * as React from "react"
import { TouchableOpacity, ViewStyle, Appearance } from "react-native"
import { observer } from "mobx-react-lite"
import { View } from "native-base"
import { color, images } from "../../theme"
import { Text } from "../text/text"
import { Image } from "../image/image"

const CONTAINER: ViewStyle = {
  flexDirection: "row",
  borderWidth: 1,
  borderColor: color.palette.gray200,
  borderRadius: 8,
}

const IMAGE_CONTAINER = {
  width: 80,
  height: 80,
  borderTopLeftRadius: 8,
  borderBottomLeftRadius: 8,
}

export interface NewsCardProps {
  /**
   * An optional style override useful for padding & margin.
   */
  title?: string
  author?: string
  image?: string,
  onPress?: () => void,

  colorScheme?: "light"|"dark"
}

/**
 * Describe your component here
 */
export const NewsCard = observer(function NewsCard(props: NewsCardProps) {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    image, title, author, onPress
  } = props
  const uri = image ? { uri: `https://app.jala.tech/img/cache/large/${image}` } : images.quick
  return (
    <TouchableOpacity style={CONTAINER} onPress={onPress}>
      <Image source={uri} resizeMode="cover" style={IMAGE_CONTAINER} />
      <View marginTop="8px" marginX="12px" flex={1} >
        <Text text={title} preset="title4" numberOfLines={2} colorScheme={colorScheme} />
        <Text text={author} marginTop="4px" preset="body3" colorScheme={colorScheme} />
      </View>
    </TouchableOpacity>
  )
})
